module.exports = __webpack_public_path__ + "static/media/Fish.a8714f55.svg";